export enum ApiPaths {
  GENERATE_OAUTH_URL = '/calendar/generate-oauth-url',
  DISCONNECT = '/calendar/disconnect',
  EXTERNAL_INVITE = '/calendar/external-invite',
  RESEND_INVITE = '/calendar/resend-invite',
  CREATE_VIRTUAL_CALENDAR = '/calendar/virtual-calendar',
  CREATE_CALENDAR_MEETING_TEMPLATE = '/calendar/meeting-template',
  UPDATE_CALENDAR_MEETING_TEMPLATE = '/calendar/meeting-template',
  GET_CALENDAR_MEETING_TEMPLATE = '/calendar/meeting-template',
  USER_CALENDAR_ORGANIZATION = '/calendar/user-calendar-organization',
  CANCEL_BOOKING = '/calendar/cancel-booking',
  REQUEST_BOOKING_RESCHEDULE = '/calendar/request-booking-reschedule',
  INTEGRATION_KOMBO_JOBS = '/integration/fetch-kombo-jobs'
}
